import { Contract } from 'components/molecules';
import Popup from 'components/molecules/popup';
import { useFormikContractHelpers } from 'hooks';
import i18next from 'i18next';
import middleware from 'middleware';
import { useEffect } from 'react';
import {
  useGetContractTemplate,
  useGetContractTemplateLightList,
} from 'services/templates/contract-template';
import { TEMPLATE_TYPE } from 'services/templates/types';

const ContractSideMenuContractTemplatesList = () => {
  const { values, setFieldValue, setErrors, setValues } =
    useFormikContractHelpers();

  const contractTemplatesList = useGetContractTemplateLightList();

  const selectedId = values.sideMenu?.customTemplate?.selectedId;

  const parentId = values.sideMenu?.customTemplate?.parentId;

  const contractTemplate = useGetContractTemplate(
    selectedId ?? '',
    {
      notFoundPath: undefined,
      notFoundToastError: i18next.t('toast-message.not-found'),
    },
    !!selectedId,
    false
  );

  useEffect(() => {
    if (!!selectedId && contractTemplate.data && parentId) {
      const contractItems = middleware.template.contractTemplate.queryToForm(
        contractTemplate.data
      );

      if (contractTemplate.data) {
        setFieldValue('items', contractItems);
        setFieldValue('sideMenu', undefined);
        setErrors({})
      }

      console.log(
        'useEffect - contractTemplate',
        selectedId,
        contractTemplate.data
      );
    }
  }, [selectedId, contractTemplate.data]);

  return (
    <Contract.SideMenu.TemplatesList.Wrapper
      templates={contractTemplatesList.data}
      templateType={TEMPLATE_TYPE.contract}
      item={template => (
        <Popup.OverwritingContractItems
          key={template.id}
          name={template.title ?? ''}
          onAdd={actions => {
            actions.close();
            setFieldValue('sideMenu.customTemplate.selectedId', template.id);
          }}
          trigger={
            <div className={'contract-custom-template-item'}>
              <div className='contract-custom-template-text'>
                {template.title ?? template.id}
              </div>
            </div>
          }
          loading={contractTemplate.isLoading}
        />
      )}
    />
  );
};

export default ContractSideMenuContractTemplatesList;
